import { render, staticRenderFns } from "./videos.vue?vue&type=template&id=66363d54&scoped=true&"
import script from "./videos.vue?vue&type=script&lang=js&"
export * from "./videos.vue?vue&type=script&lang=js&"
import style0 from "./videos.vue?vue&type=style&index=0&id=66363d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66363d54",
  null
  
)

export default component.exports